<template>
  <b-modal
    :title="attributeId ? 'Atualiza Atributo Pai' : 'Criar Atributo Pai'"
    no-close-on-backdrop
    size="lg"
    ok-only
    centered
    hide-footer
    header-bg-variant="orange"
    header-text-variant="light"
    v-model="open"
    :busy="loading"
  >
    <b-row class="container">
      <b-col cols="12" class="my-4">
        <label>Digite o nome do Atributo</label>
        <b-input
          type="text"
          v-model="attribute"
          placeholder="Nome do atributo Ex: Tamanho"
          class="form-control mt-2"
          required
        />
      </b-col>
      <b-col cols="12" md="6" class="mt-4">
        <b-button @click="close()" variant="danger" block>
          Cancelar
        </b-button>
      </b-col>
      <b-col cols="12" md="6" class="mt-4">
        <b-button v-if="attributeId" @click="update()" variant="success" block>
          Atualizar
        </b-button>

        <b-button v-else @click="save()" variant="success" block>
          Salvar
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>
import makeToast from '@/mixins/makeToast';
import InputMoney from '@/components/Inputs/InputMoney.vue'

export default {
  name: 'AttributeModal',
  mixins: [makeToast],
  emits: ['getAttribute'],

  components: { InputMoney },
  
  data() {
    return {
      loading: false,
      open: false,
      attribute: '',
      attributeId: null,
      shopkeeperId: null,
    };
  },

  methods: {
    toggleOpen({ shopkeeperId = null, id = null, name = null }) {
      this.open = !this.open;

      this.clean()
      this.shopkeeperId = shopkeeperId;

      if(id) {
        this.attribute = name;
        this.attributeId = id;
      }
    },
    save() {
      if(!this.validation) return;

      this.loading = true;
      this.$store.dispatch('startLoader');

      const data = {
        construp_user_id: this.shopkeeperId,
        name: this.attribute,
      };

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/createAttributeProduct', data)
        .then((response) => {
          if(!response.data.error) {
            this.makeToast(
              'Sucesso',
              `Atributo ${this.attribute} criado com sucesso`,
            );
            this.$emit('getAttribute');
            this.close();
          }
        })
        .catch((error) => {
          this.makeToast(
            'Erro',
            `Houve um erro ao salvar os dados`,
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    update() {
      if(!this.validation) return;

      const data = {
        id: this.attributeId,
        construp_user_id: this.shopkeeperId,
        name: this.attribute,
      };
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/updateAttributeProduct', data)
        .then((response) => {
          if(!response.data.error) {
            this.makeToast(
              'Sucesso',
              `Atributo ${this.attribute} atualizado com sucesso`,
            );
            this.$emit('getAttribute');
            this.close();
          }
        })
        .catch((error) => {
          this.makeToast(
            'Erro',
            `Houve um erro ao salvar os dados`,
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    close() {
      this.open = !this.open;
    },
    validation() {
      if(!this.name) {
        this.makeToast(
          'Erro',
          `O campo nome é obrigatório`,
        );
        return false;
      }
      return true;
    },
    clean() {
      this.attribute = null;
      this.attributeId = null;
    },
  },
};
</script>